module.exports = __webpack_public_path__ + "img/146.6b3ea8b2.jpg";